import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { DropdownMenuSubTrigger } from '../../patched-dropdown/Dropdown.mjs';

const DropdownSubTrigger = forwardRef((props, forwardedRef) => {
  return /* @__PURE__ */ jsx(
    DropdownMenuSubTrigger,
    {
      "data-scope": "dropdown",
      "data-part": "sub-trigger",
      ref: forwardedRef,
      ...props
    }
  );
});

export { DropdownSubTrigger };
//# sourceMappingURL=SubTrigger.mjs.map
